import { render } from "./VuexPasswordFormItem.vue?vue&type=template&id=74ec865e"
import script from "./VuexPasswordFormItem.vue?vue&type=script&lang=js"
export * from "./VuexPasswordFormItem.vue?vue&type=script&lang=js"
script.render = render

export default script